<template>
  <div class="view-roles addedit-role">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-1/2 justify-right">
        <h2 class="pl-2">{{ $t('labels.user_role_detail') }}</h2>
      </div>
      <div class="history w-1/2 justify-right">
        <vs-button
          color="dark"
          type="filled"
          icon-pack="feather"
          icon="icon-activity"
          @click="$router.push({ name: 'History', params: {id: id,model: model }})"
          class="float-right"
        >{{ $t('labels.history')}}</vs-button>
      </div>
    </div>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-full mb-4">
          <div class="vx-row">
            <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
              <label>{{ $t('labels.name') }}:</label>
            </div>
            <div class="vx-col sm: w-1/2 md:w-1/ mb-4">
              <span>{{ name }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
              <label>{{ $t('labels.role_description') }}:</label>
            </div>
            <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
              <span>{{ description }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row mt-4">
        <div class="vx-col w-full">
          <h3>{{ $t('labels.permissions') }}:</h3>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm: w-full md:w-3/4 mt-4">
          <vs-table :data="modules" class="permission">
            <template slot="thead">
              <vs-th>{{ $t('labels.name') }}</vs-th>
              <vs-th>{{ $t('labels.view') }}</vs-th>
              <vs-th>{{ $t('labels.add') }}</vs-th>
              <vs-th>{{ $t('labels.modify') }}</vs-th>
              <vs-th>{{ $t('labels.delete') }}</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr
                :data="tr"
                :key="indextr"
                v-for="(tr, indextr) in data"
                :class="{'bg-grey-light header_permission': tr.sub_modules.length > 0}"
              >
                <vs-th>{{tr.parent ? tr.parent.name + ' - ': '' }}{{ tr.name }}</vs-th>
                <vs-td>
                  <vs-checkbox
                    disabled
                    v-model="tr.permissions.data.view"
                    v-if="tr.sub_modules.length == 0"
                  ></vs-checkbox>
                </vs-td>
                <vs-td>
                  <vs-checkbox
                    disabled
                    v-model="tr.permissions.data.add"
                    v-if="tr.sub_modules.length == 0"
                  ></vs-checkbox>
                </vs-td>
                <vs-td>
                  <vs-checkbox
                    disabled
                    v-model="tr.permissions.data.modify"
                    v-if="tr.sub_modules.length == 0"
                  ></vs-checkbox>
                </vs-td>
                <vs-td>
                  <vs-checkbox
                    disabled
                    v-model="tr.permissions.data.delete"
                    v-if="tr.sub_modules.length == 0"
                  ></vs-checkbox>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
      <div class="vx-row justify-center">
        <vs-button
          color="primary"
          type="filled"
          icon-pack="feather"
          icon="icon-chevron-left"
          class="mr-4 mt-8 back-btn"
          align="center"
          :to="{name:'Roles'}"
        >{{ $t('labels.back') }}</vs-button>
      </div>
    </vx-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      description: "",
      modules: [],
      model: "role",
      id: this.$route.params.id
    };
  },
  mounted() {
    this.getRole();
  },
  methods: {
    goBack() {
      history.back();
    },
    async getRole() {
      let response = await this.getHTTPGetResponse(
        "role/get/" + this.$route.params.id
      );
      if (response) {
        let role = response.data.role;
        this.name = role.name;
        this.description = role.description;
        this.modules = role.modules;
      }
    }
  }
};
</script>
<style scoped>
.view-roles h3 {
  font-weight: 600;
  margin-right: 10px;
  font-size: 17px;
  text-decoration: underline;
  color: rgba(var(--vs-primary), 1) !important;
}
.view-roles label {
  font-weight: 600;
  font-size: 17px !important;
}
h2 {
  font-size: 20px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1);
}
</style>

